<div class="chart-error" [ngStyle]="{'height.px': height}">
  <cw-icon svgId="ic_show_chart" />
  <div>{{ message }}</div>
</div>
